import React from 'react'
import { Box, FormLabel, TextField, FormControl } from '@mui/material'
import InputMask from 'react-input-mask'
import { getLabel, getComputedWidth } from './utils'

export const CommonPhone = ({
  id,
  label,
  value,
  error,
  width,
  readOnly,
  helperText,
  labelRight,
  fullWidth = true,
  required = false,
  setValue,
  onChange,
  onBlur,
  mask = '(999)-999-9999',
  maskChar = null,
  inputProps,
  ...muiProps
}) => {
  const handleChange = event => {
    const newValue = event.target.value
    if (setValue) setValue(newValue)
    if (onChange) onChange(newValue)
  }

  const handleBlur = event => {
    if (onBlur) onBlur(event.target.value)
  }

  return (
    <Box data-testid={id} sx={{ width: getComputedWidth(width, fullWidth) }}>
      <FormControl fullWidth error={!!error}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 0.25,
          }}
        >
          <FormLabel sx={{ mb: 0 }}>{getLabel(label, required)}</FormLabel>
          {labelRight ? <Box sx={{ ml: 1 }}>{labelRight}</Box> : null}
        </Box>
        <InputMask
          mask={mask}
          maskChar={maskChar}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          disabled={readOnly || muiProps.disabled}
        >
          {() => (
            <TextField
              {...muiProps}
              id={id}
              value={value}
              onChange={handleChange}
              onBlur={handleBlur}
              error={!!error}
              helperText={error || helperText}
              fullWidth={fullWidth}
              disabled={readOnly || muiProps.disabled}
              type='tel'
              slotProps={{
                ...muiProps.slotProps,
              }}
              inputProps={{
                autoComplete: 'tel',
                ...inputProps,
              }}
              sx={{
                ...(readOnly && {
                  '& .MuiInputBase-input': {
                    color: theme => `${theme.palette.text.primary} !important`,
                    WebkitTextFillColor: theme =>
                      `${theme.palette.text.primary} !important`,
                  },
                }),
              }}
            />
          )}
        </InputMask>
      </FormControl>
    </Box>
  )
}
